// Calm, responsive people-management layout. All values come from design tokens;
// capability overrides remain readable on a phone instead of becoming a dense grid.

import { targetSize } from "@herefor/design-system";

export const peopleStylesheet = String.raw`
  .people {
    display: grid;
    gap: var(--herefor-space-5);
  }

  .people__heading {
    display: flex;
    flex-wrap: wrap;
    align-items: start;
    justify-content: space-between;
    gap: var(--herefor-space-4);
  }

  .people__heading h1,
  .people__heading p,
  .people__contacts p,
  .people__relationship,
  .people__capabilities p {
    margin: 0;
  }

  .people__list,
  .people__form,
  .people__contacts,
  .people__capabilities fieldset {
    display: grid;
    gap: var(--herefor-space-3);
  }

  .people__labels,
  .people__actions {
    display: flex;
    flex-wrap: wrap;
    gap: var(--herefor-space-2);
  }

  .people__label {
    display: inline-flex;
    align-items: center;
    min-block-size: ${targetSize.minimum};
    padding-inline: var(--herefor-space-3);
    border: 1px solid var(--herefor-color-border-strong);
    border-radius: var(--herefor-radius-pill);
    color: var(--herefor-color-text-muted);
    font-size: var(--herefor-font-size-sm);
  }

  .people__relationship,
  .people__contacts {
    color: var(--herefor-color-text-muted);
  }

  .people__contacts ul {
    margin: 0;
    padding-inline-start: var(--herefor-space-5);
  }

  .people__actions {
    margin-block-start: var(--herefor-space-4);
  }

  .people__capabilities {
    border: 1px solid var(--herefor-color-border);
    border-radius: var(--herefor-radius-md);
    padding: var(--herefor-space-3);
  }

  .people__capabilities summary {
    min-block-size: ${targetSize.minimum};
    display: flex;
    align-items: center;
    cursor: pointer;
    font-weight: var(--herefor-font-weight-semibold);
  }

  .people__capabilities fieldset {
    margin: var(--herefor-space-3) 0 0;
    padding: 0;
    border: 0;
  }

  .people__checkbox {
    display: flex;
    align-items: center;
    gap: var(--herefor-space-2);
    min-block-size: ${targetSize.minimum};
  }

  .people__checkbox input {
    inline-size: var(--herefor-space-5);
    block-size: var(--herefor-space-5);
  }

  @media (min-width: 48rem) {
    .people__list {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
`;
